import React, { useState } from 'react';
import {
  Alert, Box, Button, Card, CardContent, CircularProgress,
  Container, Snackbar, TextField, Typography,
} from '@mui/material';
import { userService } from '../../services/userService';

const AddTicker: React.FC = () => {
  const [ticker, setTicker] = useState('');
  const [adding, setAdding] = useState(false);
  const [snack, setSnack] = useState<{ msg: string; severity: 'success' | 'error' } | null>(null);

  const handleAdd = async () => {
    if (!ticker.trim()) return;
    setAdding(true);
    try {
      const result = await userService.addTicker(ticker.trim());
      setSnack({ msg: `${result.ticker}${result.name ? ' — ' + result.name : ''} added to watchlist`, severity: 'success' });
      setTicker('');
    } catch (e: any) {
      const msg = e?.response?.data?.detail || e?.message || 'Failed to add ticker';
      setSnack({ msg, severity: 'error' });
    } finally {
      setAdding(false);
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom>Add Ticker</Typography>

      <Card>
        <CardContent>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Add a stock ticker to the watchlist. The symbol is validated against the broker before saving.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
            <TextField
              size="small"
              label="Ticker Symbol"
              placeholder="e.g. AAPL"
              value={ticker}
              onChange={(e) => setTicker(e.target.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 10))}
              onKeyDown={(e) => { if (e.key === 'Enter') handleAdd(); }}
              inputProps={{ maxLength: 10 }}
              sx={{ width: 200 }}
            />
            <Button
              variant="contained"
              onClick={handleAdd}
              disabled={adding || !ticker.trim()}
            >
              {adding ? <CircularProgress size={20} color="inherit" /> : 'Add'}
            </Button>
          </Box>
        </CardContent>
      </Card>

      <Snackbar
        open={!!snack}
        autoHideDuration={5000}
        onClose={() => setSnack(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        {snack ? (
          <Alert severity={snack.severity} onClose={() => setSnack(null)}>
            {snack.msg}
          </Alert>
        ) : <div />}
      </Snackbar>
    </Container>
  );
};

export default AddTicker;
